// import React from "react";
// import mow from "../assets/logo.png"; 

// const Login = ({ onClose }) => {
//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="relative bg-white p-6 rounded-lg shadow-lg h-auto w-96">
//         {/* Close Button */}
//         <button
//           className="absolute top-2 right-4 text-3xl text-gray-500 hover:text-gray-700 "
//           onClick={onClose}
//         >
//           &times;
//         </button>

//         {/* Logo */}
//         <div className="flex justify-center mt-4">
//           <img src={mow} alt="Mow logo" className="h-28 w-auto" />
//         </div>

//         {/* Form Title */}
//         <h2 className="text-center text-xl font-semibold text-gray-700 mb-4">
//           Enter the details
//         </h2>

//         {/* Form */}
//         <form>
//           <div className="mb-4 text-left">
//             <label
//               htmlFor="name"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Your Name
//             </label>
//             <input
//               type="text"
//               id="name"
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               placeholder="Ranjita"
//             />
//           </div>
//           <div className="mb-6 text-left">
//             <label
//               htmlFor="referral"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Referral Code (optional)
//             </label>
//             <input
//               type="text"
//               id="referral"
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               placeholder="000000"
//             />
//           </div>
//           <button
//             type="submit"
//             className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

// src/components/Login.js


// import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { setUsername } from '../../Auth/Slice/LoginSlice';
// import mow from "../assets/logo.png";

// const Login = ({ onClose }) => {
//   const [name, setName] = useState('');
//   const dispatch = useDispatch();

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Dispatch the username to the Redux store
//     dispatch(setUsername(name));
//     // Close the login modal
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="relative bg-white p-6 rounded-lg shadow-lg h-auto w-96">
//         {/* Close Button */}
//         <button
//           className="absolute top-2 right-4 text-3xl text-gray-500 hover:text-gray-700 "
//           onClick={onClose}
//         >
//           &times;
//         </button>

//         {/* Logo */}
//         <div className="flex justify-center mt-4">
//           <img src={mow} alt="Mow logo" className="h-28 w-auto" />
//         </div>

//         {/* Form Title */}
//         <h2 className="text-center text-xl font-semibold text-gray-700 mb-4">
//           Enter the details
//         </h2>

//         {/* Form */}
//         <form onSubmit={handleSubmit}>
//           <div className="mb-4 text-left">
//             <label
//               htmlFor="name"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Your Name
//             </label>
//             <input
//               type="text"
//               id="name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               placeholder="Ranjita"
//             />
//           </div>
//           <div className="mb-6 text-left">
//             <label
//               htmlFor="referral"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Referral Code (optional)
//             </label>
//             <input
//               type="text"
//               id="referral"
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               placeholder="000000"
//             />
//           </div>
//           <button
//             type="submit"
//             className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;


// import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { setUsername } from '../../Auth/Slice/LoginSlice';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate
// import mow from "../assets/logo.png";

// const Login = ({ onClose }) => {
//   const [name, setName] = useState('');
//   const dispatch = useDispatch();
//   const navigate = useNavigate(); // Initialize useNavigate

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Dispatch the username to the Redux store
//     dispatch(setUsername(name));
//     // Redirect to home page
//     navigate('/');
//     // Close the login modal
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="relative bg-white p-6 rounded-lg shadow-lg h-auto w-96">
//         {/* Close Button */}
//         <button
//           className="absolute top-2 right-4 text-3xl text-gray-500 hover:text-gray-700"
//           onClick={onClose}
//         >
//           &times;
//         </button>

//         {/* Logo */}
//         <div className="flex justify-center mt-4">
//           <img src={mow} alt="Mow logo" className="h-28 w-auto" />
//         </div>

//         {/* Form Title */}
//         <h2 className="text-center text-xl font-semibold text-gray-700 mb-4">
//           Enter the details
//         </h2>

//         {/* Form */}
//         <form onSubmit={handleSubmit}>
//           <div className="mb-4 text-left">
//             <label
//               htmlFor="name"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Your Name
//             </label>
//             <input
//               type="text"
//               id="name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               placeholder="Ranjita"
//             />
//           </div>
//           <div className="mb-6 text-left">
//             <label
//               htmlFor="referral"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Referral Code (optional)
//             </label>
//             <input
//               type="text"
//               id="referral"
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               placeholder="000000"
//             />
//           </div>
//           <button
//             type="submit"
//             className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;


// import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { setUsername } from '..//../Auth/Slice/LoginSlice';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate
// import mow from "../assets/logo.png";

// const Login = () => {
//   const [name, setName] = useState('');
//   const dispatch = useDispatch();
//   const navigate = useNavigate(); // Initialize useNavigate

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Dispatch the username to the Redux store
//     dispatch(setUsername(name));
//     // Redirect to home page
//     navigate('/');
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="relative bg-white p-6 rounded-lg shadow-lg h-auto w-96">
//         {/* Logo */}
//         <div className="flex justify-center mt-4">
//           <img src={mow} alt="Mow logo" className="h-28 w-auto" />
//         </div>

//         {/* Form Title */}
//         <h2 className="text-center text-xl font-semibold text-gray-700 mb-4">
//           Enter the details
//         </h2>

//         {/* Form */}
//         <form onSubmit={handleSubmit}>
//           <div className="mb-4 text-left">
//             <label
//               htmlFor="name"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Your Name
//             </label>
//             <input
//               type="text"
//               id="name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               placeholder="Ranjita"
//             />
//           </div>
//           <div className="mb-6 text-left">
//             <label
//               htmlFor="referral"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Referral Code (optional)
//             </label>
//             <input
//               type="text"
//               id="referral"
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               placeholder="000000"
//             />
//           </div>
//           <button
//             type="submit"
//             className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;


import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setUsername } from "../../Redux/Slice/LoginSlice";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import mow from "../assets/logo.png";

const Login = () => {
  const [formData, setFormData] = useState({
    name: "",
    referral: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize useNavigate

  const dummyData = {
    name: "Ranjita",
    referral: "123456",
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Use FormData to manage form data
    const data = new FormData();
    data.append("name", formData.name);
    data.append("referral", formData.referral);

    // Log the FormData values
    for (let [key, value] of data.entries()) {
      console.log(`${key}: ${value}`);
    }

    // Dispatch the username to the Redux store
    dispatch(setUsername(formData.name));

    // Redirect to home page
    navigate("/");
  };

  const handleFillDummyData = () => {
    setFormData(dummyData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="relative bg-white p-6 rounded-lg shadow-lg h-auto w-96">
        {/* Logo */}
        <div className="flex justify-center mt-4">
          <img src={mow} alt="Mow logo" className="h-28 w-auto" />
        </div>

        {/* Form Title */}
        <h2 className="text-center text-xl font-semibold text-gray-700 mb-4">
          Enter the details
        </h2>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="mb-4 text-left">
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              Enter Your Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="Ranjita"
            />
          </div>
          <div className="mb-6 text-left">
            <label
              htmlFor="referral"
              className="block text-sm font-medium text-gray-700"
            >
              Enter Referral Code (optional)
            </label>
            <input
              type="text"
              id="referral"
              name="referral"
              value={formData.referral}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="000000"
            />
          </div>
          <div className="flex justify-between mb-4">
          <button
            type="submit"
            className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
          >
            Login
          </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
